import { render, staticRenderFns } from "./platcontractprocess.vue?vue&type=template&id=d64da0c0&"
import script from "./platcontractprocess.vue?vue&type=script&lang=js&"
export * from "./platcontractprocess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports